@use "../../styles/breakpoint.module.scss" as *;

.container {
    composes: repeater from "../../styles/layout.module.scss";
}

.content {
    grid-column: content;
    display: grid;
    grid-template-columns: 1fr min-content 1fr;
    align-items: start;
    gap: var(--spacer-40);

    @media ($below-mobile) {
        grid-template-columns: 1fr;
    }
}

.headline {
    composes: fontHB144 from "../../styles/typography.module.scss";
    color: var(--black);
    margin: 0;
}

.separator {
    --color: var(--red);

    &[aria-orientation="vertical"] {
        height: 100%;
    }

    @media ($below-mobile) {
        display: none;
    }
}

.rightContent {
    display: flex;
    flex-direction: column;
}

.subhead {
    composes: fontSH40 from "../../styles/typography.module.scss";
    color: var(--black);
    margin: 0;
}

.ctaWrapper {
    display: flex;
    padding-top: var(--spacer-24);
}
